// extracted by mini-css-extract-plugin
module.exports = {"separate":"index-module--separate--3b3tv"};